module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAO5JREFUOE9jtD5Z/J+BAsA4uA2wFdQBe+7w+ys4PYnXC9VKEWCNrfdWkGfADuMWhv9A6Hm2lrABPMwcDCpcUnCFqlzSDPny/mD+xIcbGW5/ewqXu/PtGcOXvz/AfBQvJEm7MYAwPjDv6S4GEIYBjDAw5FVmaFdLZAC5CBmAbKy8NZ/h/Oe7KOJYAxFkyGTNTBSFudenY2jG8AJMR56cP0OYhC2KAateHGaY9Ggjhu+wumCNQTVYYQXQySDQAfTS////GUIvthE2ABQTycCABMU9LKRB4QFKE3OBgQeKAWSA4QKQYphGdOuwyQ18ZgIAXNx0cS5xmgcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/star.png
// module id = 1076
// module chunks = 0